export default "__VITE_ASSET__D0ESRGW2__"